import CourseQ from '@/queries/CourseQ'
import SeriesQ from '@/queries/SeriesQ'
import SessionQ from '@/queries/SessionQ'
import TopicQ from '@/queries/TopicQ'
import type { Query } from '@/client/query'
import { EMPTY_RICH_TEXT_VALUE } from '@/client/services/richText/constants'
import { getSessionUrl } from '@/client/services/session'

import { getSessionHostAvatarDetails } from '@/components/Host/helpers'

import type { SessionBoxProps } from './types'

export default function getSessionBoxProps({
  session,
  currentUserId,
}: {
  session: Query
  currentUserId: number | null
}): SessionBoxProps {
  const startDate = `${session(SessionQ.start_date)}`
  const endDate = `${session(SessionQ.getComputedEndDate())}`
  const id = session(SessionQ.id) ?? 0
  const sessionSeriesId = session(SessionQ.series_id)
  const title = session(SessionQ.title)

  const topic = session.one(SessionQ.getTopic())
  const topicName = `${topic(TopicQ.name)}`
  const course = topic.one(TopicQ.getCourse())
  const series = session.one(SessionQ.getSeries())
  const seriesName = series(SeriesQ.title)
  const courseName = `${course(CourseQ.name)}`
  const courseSlug = `${course(CourseQ.slug)}`
  const description = session(SessionQ.description) ?? EMPTY_RICH_TEXT_VALUE

  const link = getSessionUrl({
    sessionId: id,
    seriesId: sessionSeriesId,
    topicName,
  })

  const countRegistrations = session(SessionQ.countSessionRegistration()) ?? 0
  const maxLearners = session(SessionQ.max_learners) ?? 0

  const isUserRegistered =
    currentUserId == null ? false : (session(SessionQ.hasUserRegistered(currentUserId)) ?? false)
  const isUserSelfReserved =
    currentUserId == null
      ? false
      : (session(SessionQ.hasUserSelfReservedSeries(currentUserId)) ?? false)

  const hosts = getSessionHostAvatarDetails(session)
  const numHosts = session(SessionQ.countAllHosts({ approved: true })) ?? 1
  const attendancePolicy = session(SessionQ.attendance_policy) ?? 'optional'

  return {
    startDate,
    endDate,
    title,
    topicName,
    seriesName,
    courseName,
    courseSlug,
    id,
    description,
    link,
    countRegistrations,
    maxLearners,
    isUserRegistered,
    isUserSelfReserved,
    hosts,
    numHosts,
    attendancePolicy,
  }
}
